var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import { FormattedMessage, injectIntl } from "@irati/utils/lang";
import { H4 } from "@irati/ui/src/Headings";
import { Para } from "@irati/ui/src/Labels";
import intercom from "@irati/utils/intercom";
import tenantSetupTracking from "@irati-tracking/tenant-setup";
import { TENANT_SETUP_TOUR_PREFIX } from "../../tour";
import { SideBarContainer, SideBarFooter, SideBarMainContent } from "./styled";
import InviteAdminButton from "../InviteAdmin/InviteAdminButton";
import Navigation from "./Navigation";
import { getCurrentTenantSetupStepConfig } from "../../helpers";
var SideBar = /** @class */ (function (_super) {
    __extends(SideBar, _super);
    function SideBar() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.toggleIntercom = function () {
            var _a = _this.props, onboardingSteps = _a.onboardingSteps, formatMessage = _a.formatMessage;
            var currentStepConfig = getCurrentTenantSetupStepConfig();
            if (!currentStepConfig) {
                return intercom.addCustomMessage(_this.props.formatMessage({ id: "setup_tenant.sidebar.help.prePopInviteAdmin" }));
            }
            var currentStep = onboardingSteps.find(function (step) { return step.stepId === currentStepConfig.stepId; });
            if (currentStep) {
                var params = {
                    step_name: formatMessage({ id: currentStepConfig === null || currentStepConfig === void 0 ? void 0 : currentStepConfig.title }),
                    step_id: currentStep.stepId,
                    step_number: currentStepConfig.order,
                    option_id: currentStep.selection
                };
                tenantSetupTracking.openIntercom(params);
            }
            intercom.addCustomMessage(_this.props.formatMessage({ id: "setup_tenant.sidebar.help.prePopMessage" }), window.location.href);
        };
        return _this;
    }
    SideBar.prototype.render = function () {
        var _a = this.props, customiseSteps = _a.customiseSteps, communicateSteps = _a.communicateSteps, inviteSteps = _a.inviteSteps;
        return (React.createElement(SideBarContainer, null,
            React.createElement(SideBarMainContent, { "data-tour": TENANT_SETUP_TOUR_PREFIX + "step01" },
                React.createElement(InviteAdminButton, null),
                React.createElement(Navigation, { customiseSteps: customiseSteps, communicateSteps: communicateSteps, inviteSteps: inviteSteps })),
            React.createElement(SideBarFooter, { "data-tour": TENANT_SETUP_TOUR_PREFIX + "step04", onClick: this.toggleIntercom },
                React.createElement(H4, { tiny: true },
                    React.createElement(FormattedMessage, { id: "setup_tenant.sidebar.help.title" })),
                React.createElement(Para, null,
                    React.createElement(FormattedMessage, { id: "setup_tenant.sidebar.help.description" })))));
    };
    return SideBar;
}(PureComponent));
export default injectIntl(SideBar);
export { SIDEBAR_WIDTH } from "./styled";
